import { css } from "lit";

export default css`
    :host {
        display: block;
        position: relative;
        width: 70rem;
        height: 100%;
        background-image: url("assets/img/minigames/dragoninvaders/playing-field.png");
        background-repeat: no-repeat;
        background-size: cover;
    }

    .score {
        color: white;
    }

    .start-screen {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        background: linear-gradient(91.7deg, rgb(50, 25, 79) -4.3%, rgb(122, 101, 149) 101.8%);
        color: #fff;
        text-align: center;
        border-radius: 10px;
        z-index: 1000; /* Ensure it's above other elements */
    }

    .game-over-screen {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        background: linear-gradient(91.7deg, rgb(50, 25, 79) -4.3%, rgb(122, 101, 149) 101.8%);
        color: #fff;
        text-align: center;
        border-radius: 10px;
        z-index: 1000; /* Ensure it's above other elements */
    }

    .game-board {
        position: relative;
        overflow: hidden; /* Ensures nothing spills out of the game area */
    }

    button {
        margin-top: 20px;
        padding: 10px 20px;
        font-size: 16px;
        cursor: pointer;
    }

`;